import React from 'react';

const Companies = () => {
  return (
    <section className="container my-5 py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="text-center mb-5">
            <h1 className="section-title mb-4">Courier Companies</h1>
            <p className="lead text-muted">Detailed information about our partner courier services</p>
          </div>
          
          <div className="row g-4">
            {/* DHL */}
            <div className="col-lg-4">
              <div className="service-card h-100">
                <div className="service-header text-center mb-4">
                  <i className="fab fa-dhl text-warning" style={{fontSize: '6rem'}}></i>
                  <h3 className="mt-3 fw-bold">DHL Courier</h3>
                </div>
                <div className="service-body">
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-map-marker-alt me-2"></i>Service Area
                    </h6>
                    <span className="badge bg-success fs-6 px-3 py-2">All Nepal Coverage</span>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-users me-2"></i>Partner Network
                    </h6>
                    <p className="text-muted">150+ local partner companies across all districts</p>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-clock me-2"></i>Delivery Time
                    </h6>
                    <ul className="list-unstyled">
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Express: 24-48 hrs</li>
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Standard: 3-5 days</li>
                    </ul>
                  </div>
                  
                  <a href="#" className="btn btn-primary w-100 book-main-btn fs-5 py-3">
                    Book with DHL
                  </a>
                </div>
              </div>
            </div>

            {/* FedEx */}
            <div className="col-lg-4">
              <div className="service-card h-100">
                <div className="service-header text-center mb-4">
                  <i className="fas fa-plane text-info" style={{fontSize: '6rem'}}></i>
                  <h3 className="mt-3 fw-bold">FedEx Cargo</h3>
                </div>
                <div className="service-body">
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-map-marker-alt me-2"></i>Service Area
                    </h6>
                    <span className="badge bg-primary fs-6 px-3 py-2">Kathmandu Valley</span>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-weight-hanging me-2"></i>Specialization
                    </h6>
                    <p className="text-muted">Air cargo, heavy parcels, express delivery</p>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-rocket me-2"></i>Features
                    </h6>
                    <ul className="list-unstyled">
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Next day delivery</li>
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Live tracking</li>
                    </ul>
                  </div>
                  
                  <a href="#" className="btn btn-primary w-100 book-main-btn fs-5 py-3">
                    Book with FedEx
                  </a>
                </div>
              </div>
            </div>

            {/* Local Express */}
            <div className="col-lg-4">
              <div className="service-card h-100">
                <div className="service-header text-center mb-4">
                  <i className="fas fa-shipping-fast text-danger" style={{fontSize: '6rem'}}></i>
                  <h3 className="mt-3 fw-bold">Local Express</h3>
                </div>
                <div className="service-body">
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-map-marker-alt me-2"></i>Service Area
                    </h6>
                    <span className="badge bg-warning fs-6 px-3 py-2">All Districts</span>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-rupee-sign me-2"></i>Affordable Rates
                    </h6>
                    <p className="text-muted">Starting from NPR 50 per kg</p>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold text-primary mb-2">
                      <i className="fas fa-headset me-2"></i>Support
                    </h6>
                    <ul className="list-unstyled">
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>24/7 customer service</li>
                      <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Same day delivery</li>
                    </ul>
                  </div>
                  
                  <a href="#" className="btn btn-primary w-100 book-main-btn fs-5 py-3">
                    Book with Local Express
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <a href="/" className="btn btn-outline-light btn-lg px-5">
              <i className="fas fa-arrow-left me-2"></i> Back to Home
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Companies;
